//@ts-nocheck
import {
  Box,
  Button,
  HStack,
  Heading,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  SimpleGrid,
  Text,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { BiPhoneCall, BiSupport } from "react-icons/bi";
import { BsWhatsapp } from "react-icons/bs";
import { Navigation } from "../../../../../../../home-tutoring/request-flow/Navigation";
import { FAQs } from "../../../../../../../home-tutoring/request-flow/PricingPage/FAQs";
import { PricingTestimonial } from "../../../../../../../home-tutoring/request-flow/PricingPage/PricingTestimonial";
import { IViewModelReturnType } from "../../../../../../../home-tutoring/request-flow/old";
import { AdminEditRequestControl } from "../../EditRequest";
import { PricingCard } from "./PricingCard";
import { motion } from "framer-motion";
import { InfoIcon } from "@chakra-ui/icons";

export type CurrencyType = { value: string; symbol: string };

export type PricingPageType = {
  onEditRequest: (payload?: any) => any;
  callNumber?: string;
  pricingOptions: Array<{
    popular?: boolean;
    lessons: number;
    duration: string;
    name: string;
    description: string;
    features: string[];
    currency: CurrencyType;
    price: number;
    teacherOptions: string[];
    separateTeacherInfo: null | any;
  }>;
  loading: boolean;
  selectedPlan?: number;
  onPlanSelected: (index: number) => Promise<any>;
  viewModel: IViewModelReturnType;
  canChangeNoOfTutors?: boolean;
  currencies: CurrencyType[];
  selectedCurrency: string;
  onCurrencySelected: (currency: string) => void;
  isLiteRequest: boolean;
  teacherNoOptions: string[];
  onTeacherNumberSelect: (name: string) => void;
  showNumOfTutors?: boolean;
  withPreAssessment?: boolean;
  isNewUser?: boolean;
};
const MotionBox = motion(Box);

export const MobileNav = ({ plan, togglePlan }) => {
  return (
    <Box
      display={{ base: "grid", lg: "none" }}
      mt="14"
      mb="-4"
      width="full"
      maxW={"440px"}
      mx="auto"
      gridTemplateColumns={"1fr 1fr"}
      border="1px solid"
      borderColor={"blue.300"}
      bg="blue.100"
      rounded="2xl"
      alignItems={"center"}
      position="relative"
    >
      <MotionBox
        bg={"#fff"}
        color="white"
        p={4}
        animate={{ x: plan === "lite" ? "100%" : "0%", opacity: 1 }}
        transition={{ duration: 0.5 }}
        cursor="pointer"
        position={"absolute"}
        inset={0}
        width="50%"
        shadow="lg"
        rounded="2xl"
        zIndex={0}
      ></MotionBox>
      <Box
        zIndex={1}
        py="4"
        px="4"
        fontSize={"lg"}
        textAlign="center"
        fontWeight="medium"
        textTransform={"capitalize"}
        onClick={() => togglePlan("standard")}
      >
        Standard plan
      </Box>
      <Box
        py="4"
        px="4"
        rounded="xl"
        fontSize={"lg"}
        fontWeight="medium"
        textAlign="center"
        textTransform={"capitalize"}
        zIndex={1}
        onClick={() => togglePlan("lite")}
      >
        Lite plan
      </Box>
    </Box>
  );
};

export const PricingPage: React.FC<PricingPageType> = observer(
  ({
    onEditRequest,
    loading,
    selectedPlan,
    pricingOptions = [],
    viewModel,
    onPlanSelected,
    callNumber = "09094526878",
    canChangeNoOfTutors = true,
    currencies,
    selectedCurrency,
    onCurrencySelected,
    isLiteRequest,
    showNumOfTutors,
    teacherNoOptions,
    onTeacherNumberSelect,
    withPreAssessment,
    isNewUser,
  }) => {
    const [plan, setPlan] = React.useState("standard");

    const togglePlan = (plan) => {
      setPlan(plan);
    };

    function isLoading(plan: number) {
      return loading && selectedPlan == plan;
    }
    return (
      <Box as="section" bg="neutral.200">
        <Navigation
          logoPosition="left"
          py={5}
          children={
            <Menu>
              <MenuButton>
                <HStack fontSize={["sm", "lg"]}>
                  <Icon fontSize={["xl", "2xl"]} as={BiSupport} />
                  <Box>
                    <Text fontSize={"xx-small"}>
                      Call us to help with booking
                    </Text>
                    <Text fontWeight={"semibold"}>{callNumber}</Text>
                  </Box>
                </HStack>
              </MenuButton>
              <MenuList>
                <MenuItem
                  as="a"
                  href={`tel:${callNumber}`}
                  py={4}
                  px={5}
                  _hover={{ color: "blue.500", cursor: "pointer" }}
                >
                  <HStack spacing={3} fontSize="lg">
                    <Icon fontSize="xl" as={BiPhoneCall} color="blue.500" />
                    <Text fontWeight={"semibold"}>Call us</Text>
                  </HStack>
                </MenuItem>
                <MenuItem
                  as="a"
                  href={`https://wa.me/${callNumber.replace("+", "")}`}
                  target="_blank"
                  py={4}
                  px={5}
                  _hover={{ color: "whatsapp.500", cursor: "pointer" }}
                >
                  <HStack spacing={3} fontSize="lg">
                    <Icon fontSize="xl" as={BsWhatsapp} color="whatsapp.500" />
                    <Text fontWeight={"semibold"}>Chat on Whatsapp</Text>
                  </HStack>
                </MenuItem>
              </MenuList>
            </Menu>
          }
        />
        <Box
          maxW="1560px"
          pt={[12, 20]}
          pb="20"
          mx="auto"
          px={{
            base: "6",
            md: "8",
          }}
        >
          <Text
            as="h1"
            fontSize={{ base: "3xl", sm: "4xl" }}
            color="gray.900"
            fontWeight="extrabold"
            textAlign={{
              sm: "center",
            }}
          >
            Select a lesson plan
          </Text>
          <Text
            mt="4"
            maxW="xl"
            mx="auto"
            fontSize={{ base: "md", sm: "xl" }}
            color="gray.600"
            textAlign={{
              sm: "center",
            }}
          >
            We'll get the most suitable tutors to help achieve your goals. You
            won't pay a dime until you've selected a tutor
          </Text>
          <Box
            mt={"6"}
            display="flex"
            flexDirection={["column", "row"]}
            justifyContent={"center"}
            alignItems={["flex-start", "center"]}
          >
            <AdminEditRequestControl
              viewModel={viewModel}
              render={(buttonProps = {}) => (
                <Button
                  colorScheme="blue"
                  textDecoration="none"
                  variant="link"
                  size={{ base: "sm", sm: "md" }}
                  display={"block"}
                  {...buttonProps}
                >
                  Edit request details
                </Button>
              )}
              onSubmit={onEditRequest}
              formType={showNumOfTutors ? "no-of-tutors" : "edit-request"}
            />
            {/* {canChangeNoOfTutors && (
              <AdminEditRequestControl
                viewModel={viewModel}
                formType="no-of-tutors"
                render={(buttonProps = {}) => (
                  <Button
                    ml={[0, 4]}
                    mt={[2, 0]}
                    colorScheme="green"
                    textDecoration="none"
                    variant="link"
                    size="md"
                    display="block"
                    {...buttonProps}
                  >
                    Select number of teachers
                  </Button>
                )}
                onSubmit={onEditRequest}
              />
            )} */}
          </Box>
          {!isLiteRequest && (
            <Box mt={{ base: "6", sm: "10" }}>
              <Select
                maxW={["500px", "300px"]}
                mx="auto"
                key={selectedCurrency}
                width="full"
                background="#fff"
                value={selectedCurrency.toLowerCase()}
                onChange={(e) => {
                  onCurrencySelected(e.target.value);
                }}
              >
                {currencies.map((currency, index) => (
                  <option
                    key={currency.value}
                    value={currency.value.toLowerCase()}
                  >
                    {currency.value.toUpperCase()}
                  </option>
                ))}
              </Select>
            </Box>
          )}
          {withPreAssessment && (
            <Box
              display="flex"
              columnGap={"4"}
              alignItems="center"
              mt="12"
              mb="-8"
              maxWidth={"md"}
              mx="auto"
              border="2px solid"
              borderColor={"blackAlpha.600"}
              p="3"
              rounded="xl"
            >
              <InfoIcon color="orange.200" h={4} w={4} />
              <Text fontSize={"sm"} color="blackAlpha.900">
                {isNewUser
                  ? "A Tuteria account has been created for you. An email has been sent to you with the details of your free pre-assessment."
                  : "This request has been added to your account with Tuteria. An email has been sent to you with the details of your free pre-assessment."}
              </Text>
            </Box>
          )}
          {pricingOptions.length > 1 && (
            <MobileNav plan={plan} togglePlan={togglePlan} />
          )}
          <SimpleGrid
            alignItems="flex-start"
            mt={{
              base: "14",
              lg: "24",
            }}
            maxWidth={{
              lg: "5xl",
            }}
            mx="auto"
            columns={{
              base: 1,
              lg: pricingOptions.length,
            }}
            spacing={{
              base: "12",
              lg: "8",
            }}
          >
            {pricingOptions.map((option, index) => {
              return (
                <PricingCard
                  key={`${option.name}-${index}`}
                  name={option.name}
                  description={option.description}
                  price={option.price}
                  popular={option.popular}
                  lessons={option.lessons}
                  duration={option.duration}
                  isLoading={isLoading(index)}
                  onClick={() => onPlanSelected(index)}
                  features={option.features}
                  selectedCurrency={option.currency}
                  teacherNoOptions={
                    canChangeNoOfTutors ? option.teacherOptions : []
                  }
                  canChangeNoOfTutors={canChangeNoOfTutors}
                  teacherStore={viewModel.teacherSelectStore}
                  teachingOptions={viewModel.childStore.teacherSplitOptions()}
                  currentPlan={plan}
                  // separateTeacherInfo={option.separateTeacherInfo}
                />
              );
            })}
          </SimpleGrid>
        </Box>
        <PricingTestimonial />
        <FAQs />
      </Box>
    );
  }
);
